export interface IDivisionProps {
  id?: string
  hospitalId: string | null
  name: string | null
  createdAt: string | null
  updatedAt: string | null
}

export default class DivisionEntity {
  private _props: IDivisionProps

  constructor(props?: IDivisionProps | null) {
    this._props = EmptyDivisionPropsFactory(props)
  }

  get props(): IDivisionProps {
    return this._props
  }

  get clone(): IDivisionProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get hospitalId(): string | null {
    return this._props.hospitalId
  }

  get name(): string | null {
    return this._props.name
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const headers = [
  { text: '部署名', value: 'name' },
  { text: '', value: 'remove', class: 'min' }
]

export const EmptyDivisionPropsFactory = (props?: Partial<IDivisionProps> | null): IDivisionProps => ({
  hospitalId: null,
  name: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
